<template>
  <div class="c-list-excerpt">{{ excerpt() }}</div>
</template>

<script>
export default {
  name: 'CIS-Resource-PagedListing-Excerpt',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    maxCharacters: {
      type: Number,
      default: 0
    }
  },
  methods: {
    excerpt() {
      const excerpt = (
        this.item.resourceExcerpt?.value?.length > 0
          ? this.item.resourceExcerpt?.value
          : this.item.pageDescription?.value
      )
        ?.replace(/<[^>]+>/g, '') // Remove HTML tags
        ?.trim();

      return this.maxCharacters > 0 && excerpt.length > this.maxCharacters
        ? excerpt.substr(0, this.maxCharacters) + '...'
        : excerpt;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/components/c-list-excerpt.scss';

.c-list-excerpt {
  @include font-styles('Arial', 2rem, 200, normal, 2.6rem, 0, $gray);
}
</style>
